import React from "react";
import { EntityCrudPage } from "./EntityCrudPage";

export function TestimonialsPage() {
  return (
    <EntityCrudPage
      title="Testimonials"
      subtitle="Manage customer testimonials."
      endpoint="/api/Testimonials"
      customerScoped
      listColumns={[
        { key: "photo", label: "Photo", type: "image" },
        { key: "name", label: "Name" },
        { key: "desgination", label: "Desgination" },
        { key: "description", label: "Description", oneLine: true },
        { key: "customerName", label: "Customer" },
        { key: "order", label: "Order" }
      ]}
      fields={[
        { key: "photo", label: "Photo", type: "image" },
        { key: "name", label: "Name", required: true },
        { key: "desgination", label: "Desgination" },
        { key: "description", label: "Description", type: "textarea" },
        { key: "order", label: "Order", type: "number" }
      ]}
    />
  );
}
